/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

/**
 * The chevron back link above the Medaica Viewer and Medaica Report pages —
 * the portal's Patient Details style: the primary chevron alone, as a link
 * or, while editing, a button; its accessible name says where it goes.
 */
export const backLinkSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
  ml: "-6px",
  border: 0,
  borderRadius: "50%",
  padding: 0,
  background: "transparent",
  cursor: "pointer",
  color: "text.primary",
  textDecoration: "none",
  "&:hover": { backgroundColor: "action.hover" },
}
